import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const SEO = ({
    title,
    description = "MyAd360 helps website and app owners maximize ad revenue using advanced tools like Google AdX, header bidding, and AI-based ad layout optimization.",
    ogTitle,
    ogDescription,
    image = "https://newdesign.myad360.com/logo.png",
    keywords
}) => {
    const location = useLocation();  // Get current page path dynamically
    const canonicalUrl = `https://newdesign.myad360.com${location.pathname}`; // Create full canonical URL

    return (
        <Helmet prioritizeSeoTags>
            <meta charSet="utf-8" />
            <title>{title || "MyAd360 – Boost Your Website Revenue | Ad Optimization Experts"}</title>
            <meta name="description" content={description} />
            <meta property="category" content="Ad Tech & Monetization" />
            <meta name="robots" content="index, follow" />
            <meta name="author" content="MyAd360 Team" />
            <meta name="language" content="en" />
            <link rel="canonical" href={canonicalUrl} />
            {ogTitle && <meta property="og:title" content={ogTitle} />}
            <meta property="og:type" content="website" />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={canonicalUrl} />
            {ogDescription && <meta property="og:description" content={ogDescription} />}
            <meta name="twitter:title" content={title || "MyAd360 – Ad Monetization Experts"} />
            <meta name="twitter:description" content={ogDescription || description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={canonicalUrl} />
            {keywords &&
                <meta name="keywords" content={keywords} />}
        </Helmet>
    );
};

export default SEO;
